<i18n>
{
    "ru": {
        "title": "Фильтр",
        "reset-all": "Сбросить все"
    }
}
</i18n>
<template>
    <div
        ref="overlay"
        class="modal-filter"
        @click="handleBackgroundClick">
        <transition name="right">
            <div v-show="isOpened" 
                class="modal-filter__main">
                <modal-content
                    :no-padding-body="true"
                    :title-border="true"
                    class="modal-filter__body">

                    <template #title>
                        <header class="modal-filter__header">
                            <div class="modal-filter__title">
                                {{ $t('title') }}
                                <span v-if="filtersCount"
                                    :class="{'modal-filter__counter_loading': count && count.loading}"
                                    class="modal-filter__counter">
                                    ({{ filtersCount }})
                                </span>
                            </div>

                            <span class="modal-filter__reset-all"
                                v-if="filtersCount"
                                @click="resetAll">{{ $t('reset-all') }}</span>

                            <span class="modal-filter__close"
                                @click="close()">
                                <svg-icon name="icon-close" />
                            </span>

                        </header>
                    </template>

                    <template #body>
                        <slot name="filter-body" :class="{'with-count': filtersCount}"></slot>
                    </template>
                </modal-content>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import isEqual from 'lodash/isEqual';
import ModalContent from '@/components/modal/ModalContent';

export default {
    name: 'ModalFilter',
    components: {
        ModalContent
    },
    props: {
        params: {
            type: [Object,Function],
            default: () => {}
        },
        isOpened: {
            type: Boolean,
            default: false
        },
        disableModalParentScroll: {
            type: Boolean,
            default: false
        },
        filtersCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            count: null   
        }
    },
    computed: {
        ...mapGetters(['isDeviceDesktop']),
        touchOptions() {
            return {
                swipeTolerance: 50,
                tapTolerance: 100
            }
        }
    },
    watch: {
        disableModalParentScroll(isDisabled) {
            // отключаем двойной скролл в модалке
            if (isDisabled) {
                this.$body.cut()
                this.$body.filterOpen()
            } else {
                this.$body.uncut()
                this.$body.filterClose()
            }
        }
    },
    methods: {
        close() {
            this.$emit('close-sidebar');
        },
        handleBackgroundClick(e) {
            if (isEqual(e.target, this.$refs.overlay)) {
                this.$emit('close-sidebar');
            }
        },
        handleBackgroundSwipe(direction) {
            if (!this.isDeviceDesktop) {
                this.$emit('close-sidebar');
            }
        },
        resetAll() {
            this.$bus.$emit('CatalogFilter::reset');
        }
    },
    globalBus: {
        'CatalogFilter::count'($event) {
            this.count = $event;
        }
    },
}
</script>

<style lang="less">
.modal-filter {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 110;

    &__body{
        .modal-content__body{
            @{mobile} &{
                background-color: @color-bg-gray;
            }
        }
    }

    &__main {
        background-color: @color-white;
        width: 100%;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 100;

        @{desktop} & {
            max-width: rem(375);

            .catalog-filter__footer {
                width: rem(385);
            }
        }
    }

    &__header {
        display: flex;
        padding-bottom: rem(4);
    }

    &__counter {
        color: @color-primary;

        position: relative;

        transition: color .2s ease;

        &:after {
            content: '';
            display: block;

            background: url('~static/img/loading-sm.gif') no-repeat 50%;

            height: 100%;
            width: 100%;

            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            opacity: 0;

            transition: opacity .2s ease;

            pointer-events: none;
        }

        &_loading {
            color: @color-white;

            &:after {
                opacity: 1;
            }
        }
    }

    &__reset-all {
        cursor: pointer;

        color: @color-red;
        font-size: rem(15);
        font-weight: 400;

        margin-left: auto;
        padding-top: rem(3);
        padding-right: rem(36);
    }

    &__close {
        cursor: pointer;

        background: none;
        border: none;
        color: @color-black;

        padding: rem(5);

        height: rem(30);
        width: rem(30);

        position: absolute;
        top: rem(10.5);
        right: rem(12);
        z-index: 3;

        svg {
            color: inherit;

            height: 100%;
            width: 100%;

            &:before{
                content: '';
                display: block;

                position: absolute;
                top: rem(-5);
                right: rem(-5);
                bottom: rem(-5);
                left: rem(-5);
            }
        }

        .hover({
            color: @color-gray-light;
        });
    }
}
</style>